import React from 'react';
import './Card.css';

const Card = ({
  children,
  variant = 'default',
  padding = 'default',
  hoverable = false,
  clickable = false,
  onClick,
  className = '',
  header,
  footer,
  ...props
}) => {
  const cardClasses = [
    'card',
    `card-${variant}`,
    `card-padding-${padding}`,
    hoverable && 'card-hoverable',
    clickable && 'card-clickable',
    className
  ].filter(Boolean).join(' ');

  const handleClick = (e) => {
    if (clickable && onClick) {
      onClick(e);
    }
  };

  return (
    <div
      className={cardClasses}
      onClick={handleClick}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      {...props}
    >
      {header && <div className="card-header">{header}</div>}
      <div className="card-content">{children}</div>
      {footer && <div className="card-footer">{footer}</div>}
    </div>
  );
};

// Card variants
export const GlassCard = (props) => <Card variant="glass" {...props} />;
export const ElevatedCard = (props) => <Card variant="elevated" {...props} />;
export const OutlineCard = (props) => <Card variant="outline" {...props} />;

export default Card;
